import { Component, Input } from '@angular/core';
import type {
  PriceItem,
  PriceGroup,
} from '@innogy/become-a-customer/shared/interfaces';
import { OfferOverview } from '@innogy/become-a-customer/shared/interfaces';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { InnogyComponentRendering } from '@core/jss-models';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { PartialAccordionTitleComponent } from '@legacy/common-ui-partials';
import { TrackInteractionDirective } from '@analytics/events';

@Component({
  selector: 'wl-price-overview-table',
  templateUrl: './price-overview-table.component.html',
  standalone: true,
  imports: [
    NgbAccordionModule,
    CommonModule,
    PartialAccordionTitleComponent,
    TrackInteractionDirective,
  ],
})
export class PriceOverviewTableComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public priceOverview?: OfferOverview;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public title?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public faIcon?: IconProp;

  calculateYearlyUnitAmount(price: PriceItem) {
    if (price.unitPrice === 0 || price.expectedPeriodAmount === undefined) {
      return 0;
    }

    return Math.round(price.expectedPeriodAmount / price.unitPrice);
  }

  trackByPricegroup(_: number, item: PriceGroup) {
    return item.id;
  }

  trackByPrice(_: number, item: PriceItem) {
    return item.id;
  }
}
